// +----------------------------------------------------------------------
// | 用户资料 / 偏好设置 / 统计
// +----------------------------------------------------------------------
import request from '../lib/request';

/** 获取资料（users + user_profiles 合并返回） */
export function getProfile() {
  return request.get('/user/profile');
}

/**
 * 修改资料（部分更新，只传要改的字段）
 * nickname / avatar 存 users 表，gender / birthday / occupation / intro 存 user_profiles 表
 * @param {{nickname?:string, avatar?:string, gender?:number, birthday?:string, occupation?:string, intro?:string}} data
 */
export function updateProfile(data) {
  return request.put('/user/profile', data);
}

/** 获取偏好设置 */
export function getSettings() {
  return request.get('/user/settings');
}

/**
 * 修改偏好设置
 * @param {{memory_enabled?:number, quick_max_questions?:number, ai_tone?:string}} data
 */
export function updateSettings(data) {
  return request.put('/user/settings', data);
}

/** 决策统计：total / decided / feedback */
export function getStats() {
  return request.get('/user/stats');
}

/**
 * 修改密码（需登录）
 *
 * 要传旧密码：光有登录态不够安全 —— 手机被临时拿到、token 泄漏，
 * 都能在不知道原密码的情况下把账号彻底占走。
 * 改完**其他设备全部下线**（当前这台不掉线），返回 { kicked } 是被踢的设备数。
 *
 * @param {string} oldPassword
 * @param {string} newPassword
 */
export function changePassword(oldPassword, newPassword) {
  return request.put('/user/password', {
    old_password: oldPassword,
    new_password: newPassword,
  });
}

/**
 * 绑定 / 换绑邮箱（需登录）
 *
 * 不要求邮件验证：这里已经是登录态，「能改自己账号」本人早已证明过。
 * 邮件验证只在「忘记密码」那条路上才有意义（那时没有任何登录态）。
 * 传空字符串 = 解绑。
 *
 * @param {string} email
 */
export function bindEmail(email) {
  return request.put('/user/email', { email });
}
